/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedPriceTile_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespTradeFreeShippingPromoTile_searchBrowse$ref: FragmentReference;
export type SbRespTradeFreeShippingPromoTile_searchBrowse = {|
  +$fragmentRefs: SbSharedPriceTile_searchBrowse$ref,
  +$refType: SbRespTradeFreeShippingPromoTile_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespTradeFreeShippingPromoTile_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedPriceTile_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'cae64eb301111d42300aca125ef0e915';
module.exports = node;
